/* eslint-disable no-console */
import toast from "react-hot-toast";
import { client } from ".";

export const deleteUsuario = async (id) => {
  try {
    const { data, error } = await client.from("usuarios").update({ habilitado: false }).eq("id", id).select();

    if (error) throw error;
    if (!data || data.length === 0) throw new Error("No se actualizó ninguna fila");

    return data[0];
  } catch (error) {
    console.error("Error en deleteUsuario:", error);
    toast.error("Error al eliminar usuario");
    throw error;
  }
};
